export default __webpack_public_path__ + "static/media/error-generating.d86ecdb4.png";